// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W446w","rootNoMargin":"styles_rootNoMargin__o7aSB"};